import crumbs from './crumbs';
import store from '@/store';

export { breadcrumbTitle } from './title';

export const setBreadcrumbsByRouteName = (routeName, options) => {
  const func = crumbs[routeName];
  if (!func) {
    alert(`Crumb function ${routeName} not found`);
  }
  store.commit('setBreadcrumbs', func(options || {}));
};
